import { render, staticRenderFns } from "./SubscriptionOverviewProducts.vue?vue&type=template&id=0712cbf8&"
import script from "./SubscriptionOverviewProducts.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOverviewProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports